import i18n from 'helpers/i18n';
import messages from './messages';
import { useDispatch } from 'react-redux';
import { Select, SelectValue } from '@teachstonellc/component-library';
import useLocale from 'hooks/useLocale';
import { update } from 'store/slices/locale';

const LOCALE_CONFIG = [
  { value: 'en', message: messages.english },
  { value: 'es', message: messages.spanish },
  { value: 'fr', message: messages.french }
] as const;

type Locale = (typeof LOCALE_CONFIG)[number]['value'];

function isLocale(value: SelectValue): value is Locale {
  return LOCALE_CONFIG.some(locale => locale.value === value);
}

function LanguageSelector() {
  const locale = useLocale();
  const dispatch = useDispatch();
  const value = locale || 'en';

  const languageOptions = LOCALE_CONFIG.map(({ value, message }) => ({
    text: i18n.ft(message),
    value
  }));

  function onLanguageSelection(selected: SelectValue) {
    if (isLocale(selected)) {
      dispatch(update(selected));
    }
  }

  return (
    <div className="text-white max-w-[550px] mx-auto min-w-[368px] relative">
      <Select
        label={i18n.ft(messages.language)}
        options={languageOptions}
        value={value}
        onChange={onLanguageSelection}
        variant="ghost"
      />
    </div>
  );
}

export default LanguageSelector;
